<div class="container" [ngClass]="isHeaderTopVisible ? '' : 'is-top-hide'" applyContextClass>
  <div class="top">
    <div class="wrapper">
      <div fxFill fxLayoutAlign="space-between center">
        <nav fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" fxShow fxHide.lt-md>
          <a class="nav-item" fxLayoutAlign="start center" routerLink="" *ngIf="true" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Accueil</a>
          <a class="nav-item" fxLayoutAlign="start center" routerLink="/jobs" routerLinkActive="active">Trouver un
            emploi</a>
          <a class="nav-item" fxLayoutAlign="start center" routerLink="/recruiters"
            routerLinkActive="active">Recruteurs</a>
          <a class="nav-item" routerLink="/candidats" routerLinkActive="active"
            fxLayoutAlign="start center">Candidats</a>
          <a class="nav-item" fxLayoutAlign="start center" routerLink="/contact" routerLinkActive="active">Contact</a>
        </nav>
        <!-- button menu-hamburger -->
        <div #btnToggleNavMobile>
          <app-menu-hamburger fxHide fxShow.lt-md></app-menu-hamburger>
        </div>
        <!-- ##############"" -->
        <div class="right" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
          <div class="info-link" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <mat-icon> mail_outline</mat-icon>
            <a href="#" class="text-on-1-line">info@data-beez.com</a>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <div class="flag-lang-container">
              <img src="../../../../assets/img/fr-flag.svg" alt="" />
            </div>
            <div class="dropdown" [appDropdown]="'lang-dropdown'">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                <span class="current-lang">Fr</span>
                <span class="bnt-toggle-menu-lang">
                  <mat-icon fxLayoutAlign="start center">keyboard_arrow_down</mat-icon>
                </span>
              </div>
              <div class="dropdown-content" id="lang-dropdown" fxLayout="column" fxLayoutGap="8px">
                <div class="dropdown-option">Fr</div>
                <div class="dropdown-option">En</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom">
    <div class="wrapper">
      <div fxFill fxLayoutAlign="space-between center">
        <div class="logo">
          <img src="../../../../assets/img/logo.svg" alt="" />
        </div>
        <app-search fxHide fxShow.gt-md></app-search>
        <div fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="start center">
          <span class="container-btn-toggle-search-mobile" fxLayoutAlign="start center" fxHide fxShow.lt-lg
            (click)="toggleSearch()">
            <mat-icon fxLayoutAlign="start center">search</mat-icon>
          </span>
          <div appHideForAuthenticatedUser>
            <div fxLayoutGap="12px" fxLayoutAlign="start center">
              <button class="btn btn__signup" routerLink="/auth/login">Se connecter</button>
              <!-- <button class="btn btn__publish">Publier un emploi</button> -->
            </div>
          </div>
          <div *ngIf="isLogedIn" class="user-welcom-container" fxLayout="row" fxLayoutAlign="start center"
            fxLayoutGap="12px">
            <div fxLayout="column">
              <span class="welcom-text" fxShow fxHide.lt-sm="">Bienvenue !</span>
              <span class="user-name" *ngIf="currentUser" fxShow fxHide.lt-sm="">{{ currentUser?.firstName }} {{
                currentUser?.lastName |
                uppercase }}</span>
            </div>
            <div class="dropdown" [appDropdown]="'dropdown-user'" fxLayout="row" fxLayoutGap="4px"
              fxLayoutAlign="start center">
              <div class="img-user">
                <img [src]="currentUser?.avatar || '../../../../assets/img/avatar-placeholder.png'" alt="">
              </div>
              <mat-icon id="btn-toggle-menu-user" fxLayoutAlign="end center">keyboard_arrow_down</mat-icon>
              <div class="dropdown-content" id="dropdown-user" fxLayout="column" fxLayoutGap="6px">
                <div class="dropdown-option " routerLink="/profile">Profile</div>
                <div class="dropdown-option " routerLink="/talent/dashboard">Dashboard</div>
                <div class="dropdown-option " (click)="logout()">Déconnexion</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- menu-mobile-container -->
  <div class="menu-navigation-container" [ngClass]="isMenuMobileVisible?'is-visible':''">
    <nav class="navigation" fxLayout="column" fxLayoutAlign="start start" fxHide fxShow.lt-md #navMobileContent>
      <a class="nav-item" fxLayoutAlign="start center" routerLink="" *ngIf="true" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">Accueil</a>
      <a class="nav-item" fxLayoutAlign="start center" routerLink="/jobs" routerLinkActive="active">Trouver un
        emploi</a>
      <a class="nav-item" fxLayoutAlign="start center" routerLink="/recruiters" routerLinkActive="active">Recruteurs</a>
      <a class="nav-item" routerLink="/candidats" routerLinkActive="active" fxLayoutAlign="start center">Candidats</a>
      <a class="nav-item" fxLayoutAlign="start center" routerLink="/contact" routerLinkActive="active">Contact</a>
    </nav>
  </div>
</div>